import { Component, OnInit, Input, AfterContentInit, Output, EventEmitter } from '@angular/core';
import { PatientInfoBlockItem, PatientInfoOption } from '../../../../core/models/physician/form-doc-builder';
import { FormService } from '../../../../core/services/v2/form.service';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-form-block-data',
  templateUrl: './form-block-data.component.html',
  styleUrls: ['./form-block-data.component.scss']
})
export class FormBlockDataComponent implements OnInit, AfterContentInit {
  @Input() blockItem: PatientInfoBlockItem;
  @Output() onChange = new EventEmitter <PatientInfoBlockItem>();

  patientInfoOptions: PatientInfoOption[];

  constructor(private loader: WindowLoaderService,
    private formService: FormService) { }

  ngOnInit() {
    this.loadOptions();
  }
  ngAfterContentInit() {
    this.setValues();
  }
  setValues() {
    if (!this.blockItem.type) {
      this.blockItem.type = 3;
    }
  }

  loadOptions() {
    this.loader.blockWithLoader(this.formService.getPatientInformationItemOptionsAll()).subscribe(
      result => {
        this.patientInfoOptions = result;
      },
      (error) => { console.error(error);}    )
  }

  valueChanged(value) {
    //console.log('valuechanged', value);
    if (value && value.length > 0)
    {
      this.blockItem.label = this.patientInfoOptions.find(po => po.patientInfo == value).friendlyName;
      this.blockItem.html5InputType = "text";
      this.onChange.emit(this.blockItem);
    }
    return true;
  }
}
